import { darken } from "polished"
import { ButtonProps } from "shared/components/buttons/types"
import { mediaQuery } from "shared/styles/mixins"
import styled from "styled-components"

import { BaseButton } from "./BaseButton"

export const AccentButton = styled(BaseButton).attrs((props) => ({
  type: props.type || "button",
}))<ButtonProps>`
  background-color: ${(props) => props.theme.button.bgColor};
  color: ${(props) => props.theme.button.textColor};
  padding: 0px 17px;

  height: ${(props) => props.theme.input.height};
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 50ms ease-in;
  -webkit-tap-highlight-color: transparent; // to remove the blue 'highlight' on android

  &:active {
    background-color: ${(props) =>
      darken(0.1, props.theme.button.bgColor)};
  }

  ${mediaQuery.mobileDevice} {
    height: ${(props) => props.theme.mobile.input.height};
  }
`
